export const COMMIT_TRIGGER = {
  ENTER: 'enter',
  SPACE: 'space',
  BLUR: 'blur',
  CLICK: 'click',
};

export const COMBOBOX_MODE = {
  SINGLE_OPTIONS: 'single-options',
  SINGLE_FREE_SOLO: 'single-free-solo',
  MULTIPLE_OPTIONS: 'multiple-options',
  MULTIPLE_FREE_SOLO: 'multiple-free-solo',
};

export const KEY = {
  ENTER: 'Enter',
  SPACE: 'Space',
};
